import { eula_fr } from './eula_fr';

export const locale_fr = {
  ...eula_fr,
  AddNew: 'Ajouter nouveau',
  SearchText: 'Saisir le texte de recherche...',
  ClearFilter: 'Effacer le filtre',
  Cancel: 'Annuler',
  OK: 'OK',
  Yes: 'Oui',
  No: 'Non',
  Description: 'Description',
  English: 'English',
  Spanish: 'Español',
  Portuguese: 'Português',
  Russian: 'русский',
  French: 'Français',
  MyProfile: 'Mon profil',
  CloseSession: 'Fermer la session',
  Settings: 'Paramètres',
  hrs: 'heures',
  EditTask: 'Français',
  DeleteTaskQuestion: '¿Etes-vous sûr de supprimer cette tâche ?',
  Delete: 'Supprimer',
  Reader: 'Lecteur',
  Contributor: 'Contributeur',
  Permissions: 'Autorisations',
  Welcome: 'Bienvenue',
  SelectEntity: 'Sélectionner une entité',
  SetEntityTitle: "Définir le titre de l'entité",
  SetEntityType: "Définir le type d'entité",
  Add: 'Ajouter',
  SelectGroup: 'Sélectionner un groupe',
  SelectGroups: 'Sélectionner des groupes',
  SelectOrganization: "Sélectionner l'organisation",
  SelectPermissions: 'Sélectionner les autorisations',
  EntityType: "Type d'entité",
  SelectRoles: 'Sélectionner les rôles',
  SelectUser: "Sélectionner l'utilisateur",
  SelectUsers: 'Sélectionner les utilisateurs',
  SelectVisibility: 'Sélectionner la visibilité',
  Name: 'Nom',
  PleaseEnterName: 'Veuillez entrer un nom',
  PleaseSelectASelector: 'Veuillez sélectionner un sélecteur',
  Save: 'Enregistrer',
  Reset: 'Réinitialiser',
  AddMembersToGroup: 'Ajouter des membres au groupe',
  AreYouSureRemove: 'Êtes-vous sûr de vouloir supprimer',
  AreYouSureRemoveMember: 'Êtes-vous sûr de vouloir supprimer {0} membre du groupe ?',
  AreYouSureRemoveMembers: 'Voulez-vous vraiment supprimer {0} membres du groupe ?',
  User: 'Utilisateur',
  Search: 'Chercher',
  AddMembers: 'Ajouter des membres',
  Reload: 'Recharger',
  AssignPermissionsToGroup: 'Attribuer des autorisations au groupe',
  Entity: 'Entité',
  Roles: 'Rôles',
  Role: 'Rôle',
  AdminRoles: "Rôles d'administration",
  DefaultRoles: 'Rôles par défaut',
  PermissionsAssigned: 'Autorisations attribuées',
  SearchEntity: 'Rechercher une entité',
  AssignNewRolesToGroup: 'Attribuer de nouveaux rôles au groupe',
  AreYouSureWantToUnassignRole: 'Attribuer de nouveaux rôles au groupe',
  AreYouSureWantToUnassignRoles: 'Êtes-vous sûr de vouloir désattribuer {0} rôles',
  AssignedRoles: 'Rôles attribués',
  AssignRoles: 'Attribuer des rôles',
  GroupParam: 'Groupe {0}',
  Members: 'Membres',
  Groups: 'Groupes',
  NewGroup: 'Nouveau Groupe',
  IdentityAdministration: 'Gestion des identités',
  OrganizationsManagement: 'Gestion des Organisations',
  UsersManagement: 'Gestion des utilisateurs',
  RolesManagement: 'Gestion des rôles',
  AdminRolesManagement: "Gestion des rôles d'administrateur",
  GroupsManagement: 'Gestion des groupes',
  PermissionsManagement: 'Gestion des permissions',
  RoleAssignmentsManagement: 'Gestion des attributions de rôles',
  DefaultRolesManagement: 'Gestion des rôles par défaut',
  AuditLogs: "Journaux d'audit",
  Organizations: 'Organisations',
  Users: 'Utilisateurs',
  Assignments: 'Devoirs',
  Logout: 'Déconnexion',
  OrganizationDatabaseHasBeenCreated: "La base de données de l'organisation a été créée",
  SomethingWentWrong: "Quelque chose s'est mal passé",
  OrganizationHasBeenBlocked: "L'organisation a été bloquée",
  OrganizationHasBeenUnblocked: "L'organisation a été débloquée",
  EditPartnerOrganization: "Modifier l'organisation partenaire",
  SelectOrRemovePartnerOrganizationMessage: 'Sélectionnez une nouvelle organisation partenaire pour {0}',
  PleaseSelectAPartnerOrganization: 'Veuillez sélectionner une organisation partenaire',
  Warning: 'Avertissement',
  TestingEndDateAutomaticallyChangedWarning:
    "La date de fin de test de l'organisation partenaire sélectionnée est antérieure à la date de fin de test actuellement sélectionnée pour cette organisation. La date de fin de test a été mise à jour automatiquement pour correspondre à celle de l'organisation partenaire.",
  OrgCannotChangePartnerStatusWarning:
    "Le statut de partenaire de cette organisation ne peut pas être modifié tant qu'elle possède des organisations enfants.",
  IsPartner: 'Est un partenaire',
  IsBlocked: 'est bloqué',
  DisplayName: "Nom d'affichage",
  Email: 'E-mail',
  PleaseEnterAValidEmail: 'Veuillez saisir une adresse e-mail valide',
  Address: 'Adresse',
  PleaseEnterAnAddress: 'Veuillez entrer une adresse',
  PartnerOrganization: 'Organisation partenaire',
  EnsureDB: 'Assurer BD',
  Unblock: 'Débloquer',
  Block: 'Bloquer',
  AddMembersToOrganization: "Ajouter des membres à l'organisation",
  OrganizationMembers: "Membres de l'organisation",
  OrganizationParam: 'Organisation {0}',
  NewOrganization: 'Nouvelle organisation',
  CreatingOrganizationMessage:
    "Création de l'organisation et de sa base de données.Cela pourrait prendre plusieurs minutes.S'il vous plaît, attendez",
  RoleAssignments: 'Assignations de rôles',
  Identity: 'Identité',
  SelectType: 'Sélectionner le type',
  Group: 'Groupe',
  IdentityType: "Type d'identité",
  SearchIdentity: "Recherche d'identité",
  NewRolesAssignment: 'Nouvelle attribution de rôles',
  Visibility: 'Visibilité',
  PleaseSelect: 'Veuillez sélectionner',
  Category: 'Catégorie',
  PleaseEnterACategory: 'Veuillez saisir une catégorie',
  AssignNewRolesToPermission: "Attribuer de nouveaux rôles à l'autorisation",
  PermissionParam: 'Autorisation {0}',
  NewPermission: 'Nouvelle autorisation',
  Organization: 'Organisation',
  AddRoleToGroups: 'Ajouter un rôle aux groupes',
  AreYouSureRemoveRole: 'Êtes-vous sûr de vouloir supprimer le rôle de',
  RoleGroups: 'Groupes de rôles',
  AddToGroups: 'Ajouter aux groupes',
  AddPermissionsToRole: 'Ajouter des autorisations au rôle',
  Permission: 'Permis',
  RolePermissions: 'Autorisations de rôle',
  AddToPermissions: 'Ajouter aux autorisations',
  AddUsersToRole: 'Ajouter des utilisateurs au rôle',
  RoleUsers: 'Utilisateurs de rôle',
  AddUsers: 'Ajouter des utilisateurs',
  RolParam: 'Rôle {0}',
  NewRole: 'Nouveau rôle',
  AddUserToGroups: 'Ajouter un utilisateur aux groupes',
  AreYouSureRemoveUserFromGroup: "Êtes-vous sûr de vouloir supprimer l'utilisateur du groupe {0}",
  AreYouSureRemoveUserFromGroups: "Êtes-vous sûr de vouloir supprimer l'utilisateur de { 0} groupes",
  GroupMembership: 'Appartenance au groupe',
  AssignPermissionsToUser: "Attribuer des autorisations à l'utilisateur",
  AssignNewRolesToUser: "Attribuer de nouveaux rôles à l'utilisateur",
  UserParam: 'Utilisateur {0}',
  PasswordMustMatch: 'Le mot de passe doit correspondre',
  NewUser: 'Nouvel utilisateur',
  PleaseSelectAnOrganization: 'Veuillez sélectionner une organisation',
  SetPassword: 'Définir le mot de passe',
  SendInvitation: "Envoyer l'invitation",
  Password: 'Mot de passe',
  ConfirmPassword: 'Confirmer le mot de passe',
  PasswordFieldBlankMessage:
    "Si vous laissez le champ du mot de passe vide, le système supposera que cet utilisateur utilisera un fournisseur d'authentification externe pour se connecter",
  AdminZone: "Zone d'administration",
  ReviewClaims: 'Examiner les revendications',
  ReviewGrants: 'Examiner les subventions',
  PageDoesNotExist: "Désolé, la page que vous avez visitée n'existe pas",
  BackHome: 'Retour à Home',
  Home: 'Home',
  DontHaveAccessToTheAdminSite: "Vous n'avez pas accès au site d'administration",
  RedirectingToLandingPage: 'Redirection vers la page de destination dans',
  Go: 'Aller',
  DefaultLanguage: 'Langue par défaut',
  PleaseSelectALanguage: 'Veuillez sélectionner une langue',
  SelectLanguage: 'Sélectionner la langue',
  Languages: 'Langues',
  to: 'à',
  from: 'de',
  DownloadTemplate: 'Télécharger le modèle',
  ConfirmationRequired: 'Confirmation requise',
  Confirmation: 'Confirmation',
  AreYouSureDeleteAllItems: 'Êtes-vous sûr de vouloir supprimer tous les éléments ?',
  AreYouSureYouWantToDelete: 'Êtes-vous sûr de vouloir supprimer les éléments sélectionnés ?',
  AreYouSureYouWantToDeleteSelected: 'Êtes-vous sûr de vouloir supprimer les éléments sélectionnés ?',
  UploadComplete: 'Téléchargement terminé',
  DeleteElements: 'Supprimer des éléments',
  DeleteItems: 'Supprimer des éléments',
  DeleteSelected: 'Supprimer la sélection',
  BulkUploadItems: 'Télécharger des éléments en masse',
  DeleteAll: 'Supprimer tout',
  OrderBy: 'Trier par',
  AnErrorOcurred: "Une erreur s'est produite",
  NoData: 'Pas de données',
  ResetFilter: 'Réinitialiser le filtre',
  SelectAll: 'Sélectionner tout',
  FilterConfirm: 'Confirmation du filtre',
  Filter: 'Filtre',
  InvertSelection: 'Inverser la sélection',
  Sort: 'Trier',
  ElementsDeletedSuccessfully: 'Les éléments ont été supprimés avec succès',
  AreYouSureDiscardChanges: 'Êtes-vous sûr de vouloir annuler ces modifications ?',
  TotalElements: 'Total des éléments',
  TotalImported: 'Total importé',
  DownloadErrorsFile: "Télécharger le fichier d'erreurs",
  Errors: 'Erreurs',
  DownloadWarningsFile: "Télécharger le fichier d'avertissements",
  Warnings: 'Avertissements',
  UnsavedValuesWarning: 'Il y a des modifications non enregistrées, êtes-vous sûr de vouloir quitter ?',
  DeletedElements: 'Éléments supprimés',
  FailDeletion: 'Échec de la suppression',
  NotSet: 'Non défini',
  CanNotDeleteOwnUser: 'Impossible de supprimer son propre utilisateur',
  CanNotDeleteOwnOrganization: 'Impossible de supprimer sa propre organisation',

  //Home
  WelcomeBack: 'Bienvenue à nouveau, {0} !',
  PageDoesNotExists: "Désolé, la page que vous avez visitée n'existe pas.",

  //Paging
  Page: 'Page',
  GoTo: 'Aller à',

  //Roles Views
  Selector: 'Sélecteur',
  AssignToScopeCreator: 'Attribuer au créateur de la portée',
  EditRole: 'Modifier le rôle',
  Edit: 'Modifier',
  EditDefaultRole: 'Modifier le rôle par défaut',
  CreateDefaultRole: 'Créer un rôle par défaut',
  NewDefaultRole: 'Nouveau rôle par défaut',
  DeleteMember: 'Supprimer le membre',
  DeleteMembers: 'Supprimer les membres',
  RemoveMember: 'Supprimer le membre',
  RemoveMembers: 'Supprimer des membres',
  CreateRole: 'Créer un rôle',
  RolesPermissions: 'Autorisations des rôles',
  GeneralProperties: 'Propriétés générales',
  SelectSelector: 'Sélectionner le sélecteur',
  AssignByDefaultToScopeCreator: 'Attribuer par défaut à Scope Creator',
  SaveChanges: 'Enregistrer les modifications',
  Allow: 'Autoriser',
  Deny: 'Refuser',
  Partners: 'Partenaires',
  EditAdminRole: "Modifier le rôle d'administrateur",
  RoleName: 'Nom du rôle',
  NewAdminRole: "Nouveau rôle d'administrateur",
  PartnersOnlyQuestion: 'Partenaires uniquement ?',
  PartnersOnly: 'Partenaires uniquement',
  DefaultRoleWarning:
    "Ce rôle par défaut génère des rôles qui sont attribués par défaut aux créateurs de certains types d'étendues.Procéder avec prudence",
  DefaultRoleDeleteWarning:
    "Ce rôle par défaut génère des rôles qui sont attribués par défaut aux créateurs de certains types d'étendues.Es - tu sûr de vouloir le supprimer?",
  ChooseIdentity: "Choisir l'identité:",
  RoleIsBeingAssignedToDefaultCreators: "Ce rôle est attribué par défaut aux créateurs de certains types d'étendues.Procéder avec prudence",
  RoleIsBeingAssignedToDefaultCreatorsDelete:
    "Ce rôle est attribué par défaut aux créateurs de certains types d'étendues.Es - tu sûr de vouloir le supprimer?",
  RoleDelete: 'Êtes-vous sûr de vouloir supprimer ce rôle ?',
  DefaultRoleDelete: 'Êtes-vous sûr de vouloir supprimer ce rôle par défaut ?',
  //Permissions
  PleaseEnterADescription: 'Veuillez saisir une description',
  AddNewRolesToPermission: "Ajouter de nouveaux rôles à l'autorisation",
  DeleteRole: 'Supprimer le rôle',
  DeleteRoles: 'Supprimer les rôles',
  AddNewPermission: 'Ajouter une nouvelle autorisation',
  AddPermission: 'Ajouter une autorisation',
  //Admin
  CreatePartnerOrganization: 'Créer une organisation partenaire',
  DeletePartnerOrganization: "Supprimer l'organisation partenaire",
  ManageDefaultRoles: 'Gérer les rôles par défaut',
  ManagePermissions: 'Gérer les autorisations',
  //Partners
  BlockOrganization: 'Bloc Organisation',
  CreateOrganization: 'Créer une organisation',
  DeleteOrganization: "Supprimer l'organisation",
  ManageLicenses: 'Gérer les licences',
  ManageRoleAssignment: 'Créer une organisation',
  //Organization
  CreateProject: "Supprimer l'organisation",
  ManageGroups: 'Gérer les licences',
  ManageOrganizationInfo: 'Gérer les attributions de rôle',
  ManageOrganizationRoleAssignments: "Gérer les attributions de rôles d'organisation",
  ManageQuarantine: 'Gérer la quarantaine',
  ManageRecycleBin: 'Gérer la corbeille',
  ManageRoles: 'Gérer les rôles',
  ManageUnitSystem: "Gérer le système d'unités",
  ManageUsers: 'Gérer les utilisateurs',
  AddOrganization: 'Ajouter une organisation',
  //Project
  CreateDrillhole: 'Créer un trou de forage',
  DeleteProject: 'Supprimer le projet',
  ManageProjectInfo: 'Gérer les informations sur le projet',
  ManageProjectRoleAssignments: 'Gérer les attributions de rôles de projet',
  ViewProjectData: 'Afficher les données du projet',
  //Ring
  CreateRing: 'Créer un ring',
  DeleteRing: 'Supprimer le ring',
  ManageRingInfo: 'Gérer les informations sur le ring',
  ManageRingRoleAssignments: 'Gérer les attributions de rôles en ring',
  ShareRing: 'Partager le ring',
  ViewRingData: 'Afficher les données de le ring',
  CreateRingDrillhole: 'Créer des trous de forage pour le ring',
  //Drillhole
  DeleteDrillhole: 'Supprimer le trou de forage',
  ManageDrillholeInfo: 'Gérer les informations sur les trous de forage',
  ManageDrillholeRoleAssignments: 'Gérer les attributions de rôles de forage',
  ViewDrillholeData: 'Afficher les données de forage',
  ManageSurveys: 'Gérer les sondages',
  SynchronizeSurveys: 'Synchroniser les sondages',

  //GroupViews
  RowsSelected: 'ligne(s) sélectionnée(s)',
  AddToMembers: 'Ajouter aux membres',
  AssignRolesToGroup: 'Attribuer des rôles au groupe',
  Scope: 'Portée',
  ScopeType: "Type d'étendue",
  SearchScope: 'étendue de la recherche',
  AddGroup: 'Ajouter un groupe',
  AddNewGroup: 'Ajouter un nouveau groupe',
  DeleteGroup: 'Supprimer le groupe',
  DeleteGroups: 'Supprimer les groupes',
  GroupLogs: 'Journaux du groupe',
  GroupInfo: 'Informations sur le groupe',
  GroupMembers: 'Membres du groupe',
  CheckGroupInfoAndUsersTabs: 'Veuillez vérifier les informations sur le groupe et les onglets des membres. Quelque chose ne va pas',

  //Organizations:
  PleaseCheckTheInfoProvided: 'Veuillez vérifier les informations fournies. Quelque chose ne va pas',
  PleaseSelectOrRemoveRow: 'Veuillez sélectionner ou supprimer une ligne',
  AreYouSureRemoveMemberFromOrg: "Êtes-vous sûr de vouloir supprimer {0} membre de l'organisation?",
  AreYouSureRemoveMembersFromOrg: "Êtes-vous sûr de vouloir supprimer {0} membres de l'organisation ?",
  DeleteUsers: 'Supprimer les utilisateurs',
  InvitationSent: 'Invitation envoyée',
  InvitationNotSent: 'Invitation non envoyée',
  ResendInvitation: "Renvoyer l'invitation",
  SendResetPasswordEmail: 'Envoyer un e-mail de réinitialisation du mot de passe',
  ResetPasswordEmailSent: 'E-mail envoyé',
  ResetPasswordEmailNotSent: 'E-mail non envoyé',
  TypeOrganizationNameToConfirm: "Saisir le nom de l'organisation à confirmer",
  CanNotDeletePartnerOrganizations: 'Impossible de supprimer les organisations partenaires',
  CanNotDeleteOrganizations: 'Impossible de supprimer les organisations',
  CheckOrganizationInfoAndUsersTabs: "Veuillez vérifier les informations sur l'organisation et les onglets des utilisateurs.Quelque chose ne va pas",
  AddNewOrganization: 'Ajouter une nouvelle organisation',
  SelectOrInviteOrganizationMaster: "Sélectionner ou inviter l'organisation principale",
  PleaseSelectInviteOrRemoveRow: 'Veuillez sélectionner, inviter ou supprimer une ligne',
  AddUser: 'Ajouter un utilisateur',
  AddNewUser: 'Ajouter un nouvel utilisateur',

  //Users
  RemoveMembership: "Supprimer l'adhésion",
  RemoveMemberships: 'Supprimer les adhésions',
  UsersLogs: "Journaux de l'utilisateur",
  AssignRolesToUser: "Attribuer des rôles à l'utilisateur",
  RolesAssigned: 'Rôles attribués',
  BalnkPasswordWarning:
    "Si vous laissez le champ du mot de passe vide, le système supposera que cet utilisateur utilisera un fournisseur d'authentification externe pour se connecter.",
  DeleteUser: "Supprimer l'utilisateur",
  ConfirmDeleteUser: "Êtes-vous sûr de vouloir supprimer l'utilisateur '{0}' avec l'adresse e-mail '{1}'?",
  UserDeleted: "L'utilisateur '{0}' avec l'adresse e-mail '{1}' a été supprimé avec succès.",
  //AuditLogs
  Timestamp: 'Horodatage',
  DisplayingFilteredItems: 'Affichage des éléments filtrés par une notification.',
  ShowAllItems: 'Afficher tous les éléments',
  NotificationTimestampMessageMinutes: 'il y a {0} minutes',
  NotificationTimestampMessageHours: 'il y a {0} heures',
  Yesterday: 'Hier',
  Read: 'Lu',
  Unread: 'Non lu',
  Action: 'Action',
  AffectedElement: 'Élément affecté',
  LinkTo: 'Lien vers',
  State: 'État',
  Date: 'Date',
  Notifications: 'Notifications',
  NotificationStatus: 'Statut de la notification',
  InApp: 'Dans l’application',
  NotificationsSettings: 'Paramètres des notifications',
  DeleteAfter: 'Supprimer après',
  OneWeek: 'Une semaine',
  OneMonth: 'Un mois',
  OneYear: 'Un an',
  ThreeMonths: 'Trois mois',
  SixMonths: 'Six mois',
  DeleteAllNotifications: 'Supprimer tout',
  SurveySynchedRingNotificationDescription: 'Le survey "{A}" a été synchronisé sur le trou de forage "{B}".',
  SurveySynchedDrillholeNotificationDescription: 'Le survey "{A}" a été synchronisé sur le Ring "{B}".',
  SurveySynchedQuarantineNotificationDescription: 'Le survey "{A}" a été synchronisé dans la quarantaine.',
  OrganizationCreationFinishedNotificationTitle: 'Organisation créée',
  OrganizationExpirationWarningNotificationTitle: 'L’organisation est sur le point d’expirer',
  OrganizationCreationErrorNotificationTitle: 'Erreur lors de la création de l’organisation',
  OrganizationIsAvailableNotificationTitle: 'Organisation disponible',
  LicenseNeedsApprovalNotificationTitle: 'La licence nécessite une approbation',
  LicenseWasRenewedNotificationTitle: 'La licence a été renouvelée',
  RingCreatedNotificationTitle: 'Ring créé',
  SurveySynchedNotificationTitle: 'Survey synchronisé',
  ProjectDeletedNotificationTitle: 'Projet supprimé',
  ProjectEditedNotificationTitle: 'Projet modifié',
  DrillholeDeletedNotificationTitle: 'Trou de forage supprimé',
  RingDeletedNotificationTitle: 'Ring supprimé',
  DrillholeMovedNotificationTitle: 'Trou de forage déplacé',
  RingMovedNotificationTitle: 'Ring déplacé',
  DrillholeEditedNotificationTitle: 'Trou de forage mis à jour',
  RingEditedNotificationTitle: 'Ring mis à jour',
  SurveySignoffNotificationTitle: 'Demande d’approbation du survey',
  DrillholeCreatedNotificationTitle: 'Trou de forage créé',
  BulkDrillholesUpdateNotificationTitle: 'Trous de forage modifiés',
  BulkDrillholesMovedNotificationTitle: 'Trous de forage déplacés',
  BulkRingsMovedNotificationTitle: 'Rings déplacés',
  BulkDrillholesDeletedNotificationTitle: 'Trous de forage supprimés',
  BulkRingsDeletedNotificationTitle: 'Rings supprimés',
  BulkProjectsDeletedNotificationTitle: 'Projets supprimés',
  BulkRingsCreatedNotificationTitle: 'Rings créés',
  BulkDrillholesCreatedNotificationTitle: 'Trous de forage créés',
  SurveyDeletedNotificationTitle: 'Survey supprimé',
  SurveyDeletedNotificationDescription: 'Le survey "{A}" a été supprimé.',

  OrganizationCreationFinishedNotificationDescription: 'L’organisation {A} a été créée avec {X} membres.',
  OrganizationExpirationWarningNotificationDescription: 'L’organisation {A} est sur le point d’expirer.',
  OrganizationCreationErrorNotificationDescription: 'Une erreur est survenue lors de la création de l’organisation {A}.',
  OrganizationIsAvailableNotificationDescription: 'L’organisation {A} est maintenant disponible.',
  LicenseNeedsApprovalNotificationDescription: 'Une licence avec le code outil {A} nécessite une approbation.',
  LicenseWasRenewedNotificationDescription: 'Une licence avec le code outil {A} a été renouvelée.',
  SurveySynchedNotificationDescription: 'Le survey "{A}" a été synchronisé sur le trou de forage "{B}".',
  ProjectDeletedNotificationDescription: 'Le projet "{A}" a été supprimé.',
  ProjectEditedNotificationDescription: 'Le projet "{A}" a été modifié.',
  DrillholeDeletedNotificationDescription: 'Le trou de forage "{A}" a été supprimé.',
  RingDeletedNotificationDescription: 'Le Ring "{A}" a été supprimé.',
  DrillholeMovedNotificationDescription: 'Le trou de forage "{B}" a été déplacé vers "{A}".',
  RingMovedNotificationDescription: 'Le Ring "{B}" a été déplacé vers le projet "{A}".',
  DrillholeEditedNotificationDescription: 'Le trou de forage "{A}" a été mis à jour',
  RingEditedNotificationDescription: 'Le Ring "{A}" a été mis à jour',
  SurveySignoffNotificationDescription: 'Une approbation a été demandée pour le survey "{A}".',
  DrillholeCreatedNotificationDescription: 'Un trou de forage nommé "{B}" a été créé sur "{A}".',
  RingCreatedNotificationDescription: 'Un Ring nommé "{B}" a été créé dans le projet "{A}".',
  BulkDrillholesUpdateNotificationDescription: '{X} trous de forage ont été modifiés sur "{B}".',
  BulkDrillholesMovedNotificationDescription: '{X} trous de forage ont été déplacés vers "{B}".',
  BulkRingsMovedNotificationDescription: '{X} Rings ont été déplacés vers le projet "{B}".',
  BulkDrillholesDeletedNotificationDescription: '{X} trous de forage ont été supprimés',
  BulkRingsDeletedNotificationDescription: '{X} Rings ont été supprimés',
  BulkProjectsDeletedNotificationDescription: '{X} projets ont été supprimés.',
  BulkRingsCreatedNotificationDescription: '{X} Rings ont été créés.',
  BulkDrillholesCreatedNotificationDescription: '{X} trous de forage ont été créés sur "{B}".',
  ForgotPasswordNotificationTitle: 'E-mail de réinitialisation du mot de passe envoyé',
  OrganizationInvitationNotificationTitle: 'Invitation à une organisation reçue',
  LicenseQRSharedNotificationTitle: 'Licence partagée avec vous',
  ToolUsageReportNotificationTitle: 'Rapport d’utilisation des outils prêt',
  OrganizationCreationFinishedNotificationTitleError: 'Erreur lors de la création de l’organisation',
  OrganizationIsAvailableNotificationTitleError: 'Erreur lors de la mise à disposition de l’organisation',
  LicenseWasRenewedNotificationTitleError: 'Erreur lors du renouvellement de la licence',
  RingCreatedNotificationTitleError: 'Erreur lors de la création du Ring',
  SurveySynchedNotificationTitleError: 'Erreur lors de la synchronisation du survey',
  ProjectDeletedNotificationTitleError: 'Erreur lors de la suppression du projet',
  ProjectEditedNotificationTitleError: 'Erreur lors de la modification du projet',
  DrillholeDeletedNotificationTitleError: 'Erreur lors de la suppression du trou de forage',
  RingDeletedNotificationTitleError: 'Erreur lors de la suppression du Ring',
  DrillholeMovedNotificationTitleError: 'Erreur lors du déplacement du trou de forage',
  RingMovedNotificationTitleError: 'Erreur lors du déplacement du Ring',
  DrillholeEditedNotificationTitleError: 'Erreur lors de la mise à jour du trou de forage',
  RingEditedNotificationTitleError: 'Erreur lors de la mise à jour du Ring',
  DrillholeCreatedNotificationTitleError: 'Erreur lors de la création du trou de forage',
  BulkDrillholesUpdateNotificationTitleError: 'Erreur lors de la modification des trous de forage',
  BulkDrillholesMovedNotificationTitleError: 'Erreur lors du déplacement des trous de forage',
  BulkRingsMovedNotificationTitleError: 'Erreur lors du déplacement des Rings',
  BulkDrillholesDeletedNotificationTitleError: 'Erreur lors de la suppression des trous de forage',
  BulkRingsDeletedNotificationTitleError: 'Erreur lors de la suppression des Rings',
  BulkProjectsDeletedNotificationTitleError: 'Erreur lors de la suppression des projets',
  BulkRingsCreatedNotificationTitleError: 'Erreur lors de la création des Rings',
  BulkDrillholesCreatedNotificationTitleError: 'Erreur lors de la création des trous de forage',
  SurveyDeletedNotificationTitleError: 'Erreur lors de la suppression du survey',
  ForgotPasswordNotificationTitleError: 'Erreur lors de l’envoi de l’e-mail de réinitialisation du mot de passe',
  OrganizationInvitationNotificationTitleError: 'Erreur lors de l’envoi de l’invitation à l’organisation',
  LicenseQRSharedNotificationTitleError: 'Erreur lors du partage de la licence',
  ToolUsageReportNotificationTitleError: 'Erreur lors de la génération du rapport d’utilisation de l’outil',

  SurveyDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression du survey "{A}".',
  OrganizationCreationFinishedNotificationDescriptionError: 'Une erreur s’est produite lors de la création de l’organisation {A}.',
  OrganizationIsAvailableNotificationDescriptionError: 'Une erreur s’est produite lors de la mise à disposition de l’organisation {A}.',
  LicenseWasRenewedNotificationDescriptionError: 'Une erreur s’est produite lors du renouvellement de la licence avec le code outil {A}.',
  SurveySynchedNotificationDescriptionError: 'Une erreur s’est produite lors de la synchronisation du survey "{A}" sur le trou de forage "{B}".',
  ProjectDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression du projet "{A}".',
  ProjectEditedNotificationDescriptionError: 'Une erreur s’est produite lors de la modification du projet "{A}".',
  DrillholeDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression du trou de forage "{A}".',
  RingDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression du Ring "{A}".',
  DrillholeMovedNotificationDescriptionError: 'Une erreur s’est produite lors du déplacement du trou de forage "{B}" vers "{A}".',
  RingMovedNotificationDescriptionError: 'Une erreur s’est produite lors du déplacement du Ring "{B}" vers le projet "{A}".',
  DrillholeEditedNotificationDescriptionError: 'Une erreur s’est produite lors de la mise à jour du trou de forage "{A}".',
  RingEditedNotificationDescriptionError: 'Une erreur s’est produite lors de la mise à jour du Ring "{A}".',
  DrillholeCreatedNotificationDescriptionError: 'Une erreur s’est produite lors de la création du trou de forage "{A}" dans "{B}".',
  RingCreatedNotificationDescriptionError: 'Une erreur s’est produite lors de la création du Ring "{A}" dans le projet "{B}".',
  BulkDrillholesUpdateNotificationDescriptionError: 'Une erreur s’est produite lors de la modification de {X} trous de forage dans "{B}".',
  BulkDrillholesMovedNotificationDescriptionError: 'Une erreur s’est produite lors du déplacement de {X} trous de forage vers "{A}".',
  BulkRingsMovedNotificationDescriptionError: 'Une erreur s’est produite lors du déplacement de {X} Rings vers le projet "{A}".',
  BulkDrillholesDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression de {X} trous de forage.',
  BulkRingsDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression de {X} Rings.',
  BulkProjectsDeletedNotificationDescriptionError: 'Une erreur s’est produite lors de la suppression de {X} projets.',
  BulkRingsCreatedNotificationDescriptionError: 'Une erreur s’est produite lors de la création de {X} Rings.',
  BulkDrillholesCreatedNotificationDescriptionError: 'Une erreur s’est produite lors de la création de {X} trous de forage dans "{B}".',
  ForgotPasswordNotificationDescriptionError: 'Une erreur s’est produite lors de l’envoi de l’e-mail de réinitialisation du mot de passe.',
  OrganizationInvitationNotificationDescriptionError: 'Une erreur s’est produite avec une invitation à l’organisation. Veuillez vérifier.',
  LicenseQRSharedNotificationDescriptionError: 'Une erreur s’est produite lors du partage de la licence.',
  ToolUsageReportNotificationDescriptionError: 'Une erreur s’est produite lors de la génération ou de l’envoi du rapport d’utilisation de l’outil.',
  SurveySynchedRingNotificationDescriptionError: 'Une erreur s’est produite lors de la synchronisation du survey "{A}" sur le trou de forage "{B}".',
  SurveySynchedDrillholeNotificationDescriptionError: 'Une erreur s’est produite lors de la synchronisation du survey "{A}" sur le Ring "{B}".',
  SurveySynchedQuarantineNotificationDescriptionError: 'Une erreur s’est produite lors de la synchronisation du survey "{A}" dans la quarantaine.',
  IsRead: 'Lu',
  RelatedEntityName: 'Nom de l’entité liée',
  RelatedEntityType: 'Type d’entité liée',
  RedirectEntityName: 'Nom de l’entité de redirection',
  RedirectEntityType: 'Type d’entité de redirection',
  Count: 'Nombre',
  Enable: 'Activer',
  SendNotificationsViaEmail: 'Envoyer les notifications par e-mail',
  TypeHeader: 'Type',

  ForgotPasswordNotificationDescription: 'Un e-mail contenant un lien de réinitialisation du mot de passe a été envoyé.',
  OrganizationInvitationNotificationDescription:
    'Vous avez été invité à rejoindre une organisation. Veuillez consulter votre e-mail pour plus de détails.',
  LicenseQRSharedNotificationDescription: 'Une licence a été partagée avec vous. Veuillez consulter votre e-mail pour plus de détails.',
  ToolUsageReportNotificationDescription: 'Le rapport d’utilisation des outils a été généré avec succès et envoyé à votre e-mail.',

  Now: 'Maintenant',
  EmptyNotificationsTextTitle: 'Vous êtes à jour !',
  EmptyNotificationsTextSubtitle: 'Vous n’avez pas de nouvelles notifications',
  LastWeek: 'La semaine dernière',
  Today: "Aujourd'hui",
  ThisWeek: 'Cette semaine',
  ThisMonth: 'Ce mois-ci',
  MarkAsRead: 'Marquer comme lu',
  MarkAsReadAll: 'Marquer comme lues',
  LogType: 'Type de journal',
  RelatedEntity: 'Entité associée',
  // Error
  UnexpectedError: 'Erreur inattendue',
  Unauthorized: 'Non autorisé',
  NoAccessToAdminSite: "Vous n'avez pas accès au site d'administration",
  LoginOutInSecs: 'Déconnexion dans {0} secondes',
  CrashError: "Oups ! Quelque chose s'est vraiment mal passé",
  SeeAllLogs: "Veuillez appuyer sur F12 et envoyer tous les journaux dans l'onglet Console lorsque vous signalez cet incident",
  ReturnHome: 'Retour à la maison',
  OrganizationUsers: "Utilisateurs de l'organisation",
  IsPartnerQuestion: "Est-ce qu'un partenaire?",

  FixResult: 'Corriger le résultat',
  NoInconsistenciesFound: 'Aucune incohérence trouvée',
  Type: 'Type',
  Parent: 'Parent',
  'Parent Type': 'Type Parent ',
  Problem: 'Problème',
  Fixed: 'Fixé',
  PleaseTryAgainLater: 'Veuillez réessayer plus tard',
  FixInconsistencies: 'Corriger les incohérences',
  AssignRoleWarning:
    "Vous attribuez des rôles : {0} à {1} au niveau de l'organisation. Les rôles seront appliqués à toutes les entités sélectionnées et {1} aura la permission de toutes les informations contenues dans {2}",
  UpdateExpiredRoleWarning:
    'Les rôles : {0} ont été précédemment attribués à {1}, mais ont expiré. La date sélectionnée remplacera la date d’expiration précédente et les rôles redeviendront actifs.',
  DoYouWantToContinue: 'Voulez-vous continuer?',
  MemberAlreadyInOrganizarion: "L'utilisateur est déjà membre de l'organisation {0}",
  YouHaveSelectedThisUserMoreThanOnce: "Vous avez sélectionné cet utilisateur plus d'une fois",
  ElementsSussessfulyDeleted: 'Éléments supprimés avec succès',
  rowsSelected: 'ligne(s) sélectionnée(s)',
  ImportCSV: 'Importer CSV',
  Licenses: 'Licenses',
  ToolCode: "Code d'outil",
  DeviceType: "Type d'appareil",
  FromDate: 'Depuis la date',
  UntilDate: "Jusqu'à la date",
  CreatedOn: 'Créé sur',
  CreatedBy: 'Créé par',
  Unlimited: 'Illimité',
  Coefficients: 'Coefficients',
  Continuous: 'Continu',
  Multishot: 'Prise multiple',
  Zupt: 'Zupt',
  Offline: 'Hors ligne',
  Flash: 'Flash',
  Notes: 'Remarques',
  AddLicense: 'Ajouter licence',
  AddNewLicense: 'Ajouter une nouvelle licence',
  PleaseEnterToolCode: "Veuillez entrer le code de l'outil",
  LicenseCopied: 'Licence copiée dans le presse-papiers',
  License: 'Licence',
  Copy: 'Copier',
  ErrorLoadingLicense: 'Erreur lors du chargement de la licence',
  ShowLicense: 'Afficher la licence',
  GoToLicense: 'Aller à la licence',
  LicenseAlreadyExists: 'Il existe déjà une licence avec les mêmes paramètres que vous avez saisis',
  PeriodOfValidity: 'Période De Validité',
  CopyLicense: 'Copier la licence',
  CopyAll: 'Copier tout',
  PleaseSelectDates: 'Veuillez sélectionner des dates',
  Project: 'Projet',
  Customer: 'Client',
  ExportCSV: 'Exporter CSV',
  Reports: 'Rapports',
  Export: 'Exporter',
  Separator: 'Séparateur',
  Tab: 'Onglet',
  Semicolon: 'Point-virgule',
  Comma: 'Virgule',
  ThereWasAProblemCreatingLicense: 'Il y a eu un problème lors de la création de la licence.Veuillez contacter un administrateur.',
  ExpirationDate: "Date d'expiration",
  UpdateRoleAttributes: 'Modifier les attributs de rôle',
  Update: 'Modifier',
  AllowedDevices: 'Appareils autorisés',
  RoleExpirationDate: "Date d'expiration du rôle",
  PleaseEnterExpirationDate: "Veuillez entrer une date d'expiration",
  MaximumLicenseDueDate: "Date d'échéance maximale de la licence",
  PleaseEnterMaxDueDate: "Veuillez saisir la date d'échéance maximale de la licence",
  MaxLicensesPeriodInDays: 'Durée maximale de la licence en jours',
  PleaseEnterMaxLicensesPeriodInDays: 'Veuillez saisir la durée maximale de la licence en jours',
  MaxNumberOfLicensesPerMonth: 'Nombre maximal de licences par mois',
  PleaseEnterMaxNumberOfLicensesPerMonth: 'Veuillez entrer le nombre maximum de licences par mois',
  SignOffPending: 'Signature en attente',
  SignedOffBy: 'Signé par',
  SignedOffOn: 'Déconnecté le',
  SignOff: 'Approuver',
  Refuse: 'Refuser',
  NeedsSignOff: 'Approbation requise',
  SelectedUserAlreadyHasTheSelectedRoles: "L'utilisateur sélectionné a déjà les rôles: {0}.",
  CanCreateUnlimitedLicense: "Peut créer des licences qui n'expirent pas",
  CanCreateRecurrentLicenses: 'Peut créer des licences récurrentes',
  Recurrence: 'Récurrence',
  Activated: 'Activé',
  Deactivated: 'Désactivé',

  Logs: 'Journaux',
  LicenseLogs: 'Journaux de licence',
  ViewLogs: 'Afficher les journaux',
  UserName: "Nom d'utilisateur",
  LicenseCreation: 'Création de licence',
  LicenseUpdate: 'Mise à jour de la licence',
  LicenseSignedOff: 'Licence signée',
  LicenseRejected: 'Licence rejetée',
  ErrorCreatingLicenseMaximumLicenseDueDate: 'Erreur de création de licence',
  ErrorCreatingLicenseMaxLicensesPeriodInDays: 'Erreur de création de licence',
  ErrorCreatingLicenseMaxLicenseNumber: 'Erreur de création de licence',
  ErrorCreatingLicenseAllowedDevices: 'Erreur de création de licence',
  ErrorUpdatingLicenseMaximumLicenseDueDate: 'Erreur de mise à jour de la licence',
  ErrorUpdatingLicenseMaxLicensesPeriodInDays: 'Erreur de mise à jour de la licence',
  ErrorUpdatingLicenseAllowedDevices: 'Erreur de mise à jour de la licence',
  LicenseCreationDescription: "Une licence a été créée par {0} pour l'appareil {1} et le type d'outil {2}",
  LicenseUpdateDescription: 'Une licence a été changée par {0}',
  LicenseCreationDescriptionExtraData:
    "Une licence a été créée par {0} avec les paramètres suivants : Type de dispositif : {1}, Numéro d'outil : {2}, {3}, Projet : {4}, Client : {5}.",
  LicenseUpdateDescriptionExtraData:
    "Une licence a été mise à jour par {0}.<br> Paramètres précédents : Type de dispositif : {1}, Numéro d'outil : {2}, {3}, Projet : {4}, Client : {5}.<br> Paramètres actuels : Type de dispositif : {6}, Numéro d'outil : {7}, {8}, Projet : {9}, Client : {10}.",
  LicenseDescriptionTimeData: 'de {0} à {1}',
  LicenseSignedOffDescription: "{0} a approuvé la licence créée par {1} pour l'appareil {2} et le type d'outil {3}",
  LicenseRejectedDescription: "{0} a rejetée la licence créée par {1} pour l'appareil {2} et le type d'outil {3}",
  ErrorCreatingLicenseMaximumLicenseDueDateDescription:
    "Une erreur s'est produite lors de la création de la licence. La licence ne peut pas avoir une date d'échéance supérieure à la date d'échéance maximale autorisée.",
  ErrorCreatingLicenseMaxLicensesPeriodInDaysDescription:
    "Une erreur s'est produite lors de la création de la licence. La licence doit être valide pour une période inférieure à la période de licence maximale autorisée",
  ErrorCreatingLicenseMaxLicenseNumberDescription:
    "Une erreur s'est produite lors de la création de la licence. L'utilisateur a dépassé le nombre maximum de licences qui peuvent être créées au cours d'un mois.",
  ErrorCreatingLicenseAllowedDevicesDescription:
    "Une erreur s'est produite lors de la création de la licence. L'utilisateur n'a pas les autorisations pour créer des licences pour l'appareil spécifié.",
  ErrorUpdatingLicenseMaximumLicenseDueDateDescription:
    "Une erreur s'est produite lors de la mise à jour de la licence. La licence ne peut pas avoir une date d'échéance supérieure à la date d'échéance maximale autorisée.",
  ErrorUpdatingLicenseMaxLicensesPeriodInDaysDescription:
    "Une erreur s'est produite lors de la mise à jour de la licence. La licence doit être valide pour une période inférieure à la période de licence maximale autorisée",
  ErrorUpdatingLicenseAllowedDevicesDescription:
    "Une erreur s'est produite lors de la mise à jour de la licence. L'utilisateur n'a pas les autorisations pour définir des licences pour l'appareil spécifié.",
  ExportingVeryLargeNumberOfItems:
    "Vous essayez d'exporter un très grand nombre d'éléments, cela peut prendre un certain temps. Êtes-vous sûr de vouloir continuer?",
  InitializingOrganization: "Organisation d'initialisation. Les utilisateurs seront bientôt disponibles",
  InvalidToolCode: "Le code de l'outil doit comporter exactement quatre chiffres.",
  EditRoles: 'Modifier les rôles',
  EditRolesMessage: "Modifier les rôles d'utilisateur",
  RolesWillBeRemoved: 'Les rôles suivants seront supprimés : {0}. ',
  RolesWillBeAssigned: 'Les rôles suivants seront attribués : {0}. ',
  LicenseAttributesWillBeUpdated: 'Les attributs du rôle License Manager seront mis à jour.',
  CheckDatabases: 'Vérifier les bases de données',
  CheckDatabasesComplete: "L'opération de vérification des bases de données est terminée",
  DatabaseCheckResultsModalTitle: 'Résultats de la vérification de la base de données: ',
  ViewResults: 'Voir les résultats',
  CheckDatabaseResult: 'Résultat de la vérification de la base de données',
  OrganizationName: "Nom de l'organisation",
  Status: 'Statut',
  Success: 'Succès',
  Error: 'Erreur',
  AddAssignments: 'Ajouter des devoirs',
  GroupsLogs: 'Journaux de groupe',
  RelatedUser: 'Utilisateur associé',
  OrganizationInfo: "Information de l'organisation",
  LicenseDetails: 'Détails de la licence',
  DatabaseCheckLogs: 'Journaux de vérification des bases de données',
  CheckingDatabases: 'Vérification des bases de données...',
  DatabaseLogs: 'Journaux de la base de données',
  DatabaseCheckLogsResult: 'Résultats de la vérification de la base de données',
  DatabaseCheckResultOnDate: 'Résultat de la vérification de la base de données le {0}',
  ExportingProcessStarted: "Le processus d'exportation a démarré, le téléchargement va commencer sous peu",
  ExportOrganization: "Exporter l'organisation",
  ImportOrganization: "Importer l'organisation",
  UploadOrganizationBackup: "Télécharger la sauvegarde de l'organisation",
  AddOrganizationFile: "Cliquez ou faites glisser le fichier de sauvegarde de l'organisation dans cette zone pour le télécharger",
  ThisUserIsOrganizationMaster: "Cet utilisateur a déjà été sélectionné comme maître de l'organisation",
  RemainingLicensesMessage: 'Il vous reste un total de {0} licences restantes pour ce mois',
  MaxLicenseNumberReached: 'Vous avez atteint le nombre maximum de licences pour ce mois-ci',
  EULATitle: "Contrat de licence d'utilisateur final (EULA)",
  OrganizationIsExporting: "L'organisation est en cours d'exportation, veuillez patienter...",
  ErrorExportingOrganization: "Une erreur s'est produite lors de l'exportation de l'organisation {0}. Veuillez réessayer",
  ExportingOrganizationSuccess:
    "Le processus d'exportation a commencé. Une fois terminé, nous vous enverrons le lien de téléchargement par courrier électronique.",
  ExportImportLogs: "Journaux d'exportation et d'importation",
  CanNotDeleteOrganizationWhileExporting:
    "L'organisation {0} est en cours d'exportation et ne peut pas être supprimée pour le moment. Veuillez patienter et réessayer dans un moment.",
  CheckingIfOrganizationExists: "Vérifier si l'organisation existe...",
  RestoreOrganizationConfirmDialog:
    'Cette organisation existe déjà, voulez-vous continuer ? Toutes les données de cette organisation seront écrasées par les données de sauvegarde.',
  StatusCode: "Code d'état",
  Message: 'Message',
  Traces: 'Traces',
  ViewTrace: 'Afficher la trace',
  ImportExportDevLogs: 'Importer et exporter les journaux de développement.',
  DevLogs: 'Jour. Développement',
  DevLogsShort: 'Reg. Desarrollo',
  ImportExport: 'Import/Export',
  ImportingOrganizationStarted: "Le processus d'importation a commencé",
  ImportingOrganizationSuccess:
    "Le processus d'importation a commencé, une fois terminé, nous vous enverrons une notification à votre adresse électronique",
  ErrorImportingOrganization: "Une erreur s'est produite lors de l'importation de l'organisation. Veuillez réessayer",
  Importing: 'Importation...',
  ResetLockout: 'Réinitialiser le verrouillage',
  LockoutReset: 'Verrouillage réinitialisé',
  LockoutNotReset: 'Verrouillage non réinitialisé',
  HangfireDashboard: 'Tableau de bord Hangfire',
  LastImportDate: "Cette organisation a été restaurée pour la dernière fois à partir d'une sauvegarde le ",
  EventDuration: 'Durée de l’événement (heures)',
  ScheduledEvents: 'Événements programmés',
  ScheduledEvent: 'Événement programmé',
  VisibilityStartDate: 'Date de début de visibilité',
  VisibilityEndDate: 'Date de fin de visibilité',
  EventType: 'Type d’événement',
  ScheduledUpdate: 'Mise à jour programmée',
  Announcement: 'Annonce',
  EventStart: 'Début de l’événement',
  ScheduledEventsTableError: 'Une erreur s’est produite lors du chargement du tableau des événements.',
  EditScheduledEvent: 'Modifier l’événement programmé',
  NewScheduledEvent: 'Nouvel événement programmé',
  UploadBanner: 'Télécharger une bannière',
  Banner: 'Bannière',
  BannerSelectInfoMessage:
    'Les images de bannière doivent utiliser un ratio de 8:1 (largeur sur hauteur). Les résolutions recommandées incluent 800×100 pixels, 1600×200 pixels ou toute autre taille respectant ce ratio. Vous pourrez recadrer l’image avant de l’enregistrer.',
  LocalizedAnnouncementInformation: 'Informations d’annonce localisées',
  LocalizedAnnouncementInformationDescription:
    'Pour chaque langue sélectionnée, une bannière ou un message avec la description fournie sera affiché à tous les utilisateurs utilisant cette langue. Si une bannière et une description sont fournies, la description sera utilisée comme texte alternatif de la bannière. Si l’utilisateur utilise une langue non ajoutée, les informations d’annonce en anglais seront utilisées si disponibles, sinon celles de la première langue de la liste seront utilisées.',
  AddAtLeastOneLanguage: 'Veuillez sélectionner au moins une langue',
  PleaseEnterVisibilityRange: 'Veuillez saisir une plage de visibilité',
  PleaseLoadImageIfNoDescription: 'Si aucune description n’est fournie, une image de bannière doit être téléchargée',
  PleaseEnterDescriptionIfNoImage: 'Si aucune image de bannière n’est fournie, une description textuelle doit être ajoutée',
  PleaseEnterScheduledUpdateStartMoment: 'Veuillez saisir un moment de début pour la mise à jour',
  PleaseEnterScheduledUpdateDuration: 'Veuillez saisir une durée en heures pour la mise à jour',
  Link: 'Lien',
  SelectBannerArea: 'Sélectionner la zone de la bannière',
  ScheduledMaintenanceText:
    'Maintenance programmée : La plateforme cloud fera l’objet d’une maintenance programmée le {0}. Les services peuvent être interrompus pendant une durée estimée de {1} heures, à partir de {2}',

  AdminRolesTableError: "Une erreur s'est produite lors du chargement des rôles d'administrateur. Veuillez réessayer",
  AuditLogsTableError: "Une erreur s'est produite lors du chargement des journaux d'audit. Veuillez réessayer",
  DefaultRolesTableError: "Une erreur s'est produite lors du chargement des rôles par défaut. Veuillez réessayer",
  GroupsTableError: "Une erreur s'est produite lors du chargement des groupes. Veuillez réessayer",
  ErrorSavingGroupProperties: "Une erreur s'est produite lors de l'enregistrement des propriétés du groupe. Veuillez réessayer",
  ErrorAddingGroupMembers: "Une erreur s'est produite lors de l'ajout de membres au groupe. Veuillez réessayer",
  GroupRolesTableError: "Une erreur s'est produite lors du chargement des rôles du groupe. Veuillez réessayer",
  LicensesTableError: "Une erreur s'est produite lors du chargement des licences. Veuillez réessayer",
  LicenseLogsTableError: "Une erreur s'est produite lors du chargement des journaux de licence. Veuillez réessayer",
  OrganizationsTableError: "Une erreur s'est produite lors du chargement des organisations. Veuillez réessayer",
  ErrorAddingOrganizationMembers: "Une erreur s'est produite lors de l'ajout de nouveaux membres à l'organisation. Veuillez réessayer.",
  ErrorRemovingOrganizationMembers: "Une erreur s'est produite lors de la suppression des nouveaux membres de l'organisation. Veuillez réessayer",
  DatabaseLogsTableError: "Une erreur s'est produite lors du chargement des journaux de la base de données. Veuillez réessayer",
  PermissionsTableError: "Une erreur s'est produite lors du chargement des autorisations. Veuillez réessayer",
  ErrorSavingPermissions: "Une erreur s'est produite lors de l'enregistrement des propriétés des autorisations. Veuillez réessayer",
  ErrorAddingPermissionRoles: "Une erreur s'est produite lors de l'ajout de permissions au rôle. Veuillez réessayer",
  ErrorRemovingPermissionRoles: "Une erreur s'est produite lors de la suppression de la permission du rôle. Veuillez réessayer",
  RoleAssignmentsTableError: "Une erreur s'est produite lors du chargement des attributions de rôle. Veuillez réessayer",
  RoleListTableError: "Une erreur s'est produite lors du chargement des rôles. Veuillez réessayer",
  LockoutNotResetError: "Une erreur s'est produite lors de la réinitialisation du verrouillage. Veuillez réessayer",
  UsersTableError: "Une erreur s'est produite lors du chargement de la liste des utilisateurs. Veuillez réessayer",
  ErrorAddingGroup: "Une erreur s'est produite lors de l'ajout du groupe. Veuillez réessayer",
  ErrorRemovingGroup: "Une erreur s'est produite lors de la suppression du groupe. Veuillez réessayer",
  UserLogsTableError: "Une erreur s'est produite lors du chargement des journaux des utilisateurs. Veuillez réessayer",
  UserRolesTableError: "Une erreur s'est produite lors du chargement des rôles des utilisateurs. Veuillez réessayer",
  InvitationNotSentErrorMessage: "Une erreur s'est produite lors de l'envoi de l'invitation. Veuillez réessayer",
  ResetPasswordEmailNotSentMessage: "Une erreur s'est produite lors de l'envoi de l'e-mail de réinitialisation du mot de passe. Veuillez réessayer.",
  ErrorEditingLicenseAttributes: "Une erreur s'est produite lors de l'édition de la licence. Veuillez réessayer",
  ErrorDeletingUser: "Une erreur s'est produite lors de la suppression de l'utilisateur. Veuillez réessayer.",
  PaginationTotal: 'Afficher {0} éléments de {1}',
  PaginationTotalItemsText: 'Affichage de {0}-{1} sur {2} éléments',
  MinutesAbbreviation: 'min',
  EditTutorialInformation: 'Modifier les informations du tutoriel',
  Order: 'Ordre',
  VideoOrder: 'Ordre de la vidéo',
  FuntionTitle: 'Fonction',
  VideoFunction: 'Fonction de la vidéo',
  PleaseEnterVideoOrder: 'Veuillez saisir l’ordre de la vidéo',
  AddFunction: 'Ajouter une fonction',
  FunctionAlreadyExistsWarning: 'Une fonction avec ce nom existe déjà. Veuillez vérifier.',
  SearchTutorials: 'Rechercher des tutoriels',
  VideoTutorials: 'Tutoriels vidéo',
  ManageVideoTutorialData: 'Gérer les données des tutoriels vidéo',
  SynchronizeThisVideoAfterOperationFinishes: "Synchroniser cette vidéo après la fin de l'opération",
  AddTutorialInformation: 'Ajouter des informations sur le tutoriel',
  VideoId: 'ID de la vidéo',
  TutorialEnabledLabel: 'Cette vidéo tutorielle est prête à être visionnée par l’utilisateur.',
  Title: 'Titre',
  FunctionTitle: 'Fonction',
  View: 'Voir',
  SynchronizeVideos: 'Synchroniser les vidéos',
  Synchronize: 'Synchroniser',
  ErrorCreatingVideo: 'Une erreur s’est produite lors de la création de la vidéo. Veuillez vérifier les informations saisies et réessayer.',
  ErrorEditingVideo: 'Une erreur s’est produite lors de la modification de la vidéo. Veuillez vérifier les informations saisies et réessayer.',
  Duration: 'Durée',
  SelectOrInviteUser: 'Sélectionner ou inviter un utilisateur',
  SelectOrInviteUsers: 'Sélectionner ou inviter des utilisateurs',
  CheckDB: 'Vérifier la base de données',
  ManageGlobalLicenses: 'Gérer les licences globales',
  ManageRoleAssignments: 'Gérer les attributions de rôles',
  ManageUnitSystems: "Gérer les systèmes d'unités",
  ShareDrillhole: 'Partager des trous de forage',
  SignOffSurveys: 'Signer des enquêtes',
  ViewSurveyData: "Afficher les données d'enquête",
  OrganizationLogs: "Journaux de l'organisation",
  ExportOrganizationDBLogsModalTitle: "Exporter le journal de contrôle à partir des bases de données de l'organisation",
  Format: 'Format',
  Restore: 'Restaurer',
  RestoreBackupConfirmMessage:
    "Voulez-vous restaurer cette sauvegarde ? Toute modification apportée à l'organisation après la création de la sauvegarde sera perdue.",
  RestoreBackupSuccessMessage: 'Le processus de restauration de sauvegarde a démarré. Une fois terminé, nous vous enverrons un e-mail.',
  Backups: 'Sauvegardes',
  OrganizationBackups: 'Sauvegardes organisationnelles',
  PreviousValue: 'Valeur précédente',
  PreviousHierarchy: 'Hiérarchie précédente',
  Source: 'Source',
  SourceTitle: 'Source du journal avec la date {0}, la valeur précédente "{1}" et la hiérarchie précédente "{2}"',
  ViewSource: 'Voir la source',
  ScopeId: 'Context Id',
  CurrentParentId: 'Id du parent actuel',
  PreviousParentId: 'Id du parent précédent',
  CurrentHierarchy: 'Hiérarchie actuelle',
  ScopeLogType: 'Type de journal de contexte',
  Descendants: 'Descendants',
  ViewDescendants: 'Descendants de la vue',
  DatabaseInconsistencyLogs: "Journaux d'incohérence de la base de données",
  InconsistencyFixStartedMessage:
    "Le processus de correction des incohérences a commencé. Une fois terminé, le résultat sera visible sur la page Logs de l'organisation.",
  OrganizationIsLocked:
    'Cette organisation est actuellement verrouillée car elle est utilisée dans un autre processus. Veuillez patienter et réessayer dans quelques instants.',
  Statistics: 'Statistiques',
  Last24Hours: 'Dernières 24 heures',
  Last3Days: 'Les 3 derniers jours',
  Last7Days: 'Les 7 derniers jours',
  Last28Days: 'Les 28 derniers jours',
  FilterByDate: 'Filtre par date',
  Projects: 'Projets',
  Surveys: 'Enquêtes',
  ProjectsNumber: 'Nombre de projets',
  UsersNumber: "Nombre d'utilisateurs",
  SurveysNumber: "Nombre d'enquêtes",
  CreationDate: 'Date de création',
  LastUpdate: 'Dernière mise à jour',
  CustomDateRange: 'Plage de dates personnalisée',
  ErrorUpdatingRole: "Une erreur s'est produite lors de la mise à jour des autorisations du rôle. Veuillez réessayer.",

  WorkingHours: 'Heures de travail',
  PleaseEnterWorkingHours: 'Veuillez entrer les heures de travail',

  Weekly: 'Hebdomadaire',
  Monthly: 'Mensuel',
  Quarterly: 'Trimestriel',
  SharingDataSettings: 'Paramètres de partage des données',
  EmailAddresses: 'Adresses email',
  EmailFrequency: 'Fréquence des emails',

  Country: 'Pays',
  PleaseSelectCountry: 'Veuillez sélectionner un pays',

  // Country names
  Afghanistan: 'Afeganistão',
  Albania: 'Albânia',
  Algeria: 'Argélia',
  Andorra: 'Andorra',
  Angola: 'Angola',
  'Antigua and Barbuda': 'Antígua e Barbuda',
  Argentina: 'Argentina',
  Armenia: 'Arménia',
  Australia: 'Austrália',
  Austria: 'Áustria',
  Azerbaijan: 'Azerbaijão',
  Bahamas: 'Bahamas',
  Bahrain: 'Bahrein',
  Bangladesh: 'Bangladesh',
  Barbados: 'Barbados',
  Belarus: 'Bielorrússia',
  Belgium: 'Bélgica',
  Belize: 'Belize',
  Benin: 'Benim',
  Bhutan: 'Butão',
  Bolivia: 'Bolívia',
  'Bosnia and Herzegovina': 'Bósnia e Herzegovina',
  Botswana: 'Botswana',
  Brazil: 'Brasil',
  Brunei: 'Brunei',
  Bulgaria: 'Bulgária',
  'Burkina Faso': 'Burkina Faso',
  Burundi: 'Burundi',
  Cambodia: 'Camboja',
  Cameroon: 'Camarões',
  Canada: 'Canadá',
  'Cape Verde': 'Cabo Verde',
  'Central African Republic': 'República Centro-Africana',
  Chad: 'Chade',
  Chile: 'Chile',
  China: 'China',
  Colombia: 'Colômbia',
  Comoros: 'Comores',
  'Costa Rica': 'Costa Rica',
  'Côte d’Ivoire': 'Costa do Marfim',
  Croatia: 'Croácia',
  Cuba: 'Cuba',
  Cyprus: 'Chipre',
  'Czech Republic': 'República Checa',
  'Democratic Republic of the Congo': 'República Democrática do Congo',
  Denmark: 'Dinamarca',
  Djibouti: 'Djibouti',
  Dominica: 'Dominica',
  'Dominican Republic': 'República Dominicana',
  'East Timor': 'Timor-Leste',
  Ecuador: 'Equador',
  Egypt: 'Egito',
  'El Salvador': 'El Salvador',
  'Equatorial Guinea': 'Guiné Equatorial',
  Eritrea: 'Eritreia',
  Estonia: 'Estónia',
  Ethiopia: 'Etiópia',
  Fiji: 'Fiji',
  Finland: 'Finlândia',
  France: 'França',
  Gabon: 'Gabão',
  Gambia: 'Gâmbia',
  Georgia: 'Geórgia',
  Germany: 'Alemanha',
  Ghana: 'Gana',
  Greece: 'Grécia',
  Grenada: 'Granada',
  Guatemala: 'Guatemala',
  Guinea: 'Guiné',
  'Guinea-Bissau': 'Guiné-Bissau',
  Guyana: 'Guiana',
  Haiti: 'Haiti',
  Honduras: 'Honduras',
  Hungary: 'Hungria',
  Iceland: 'Islândia',
  India: 'Índia',
  Indonesia: 'Indonésia',
  Iran: 'Irã',
  Iraq: 'Iraque',
  Ireland: 'Irlanda',
  Israel: 'Israel',
  Italy: 'Itália',
  Jamaica: 'Jamaica',
  Japan: 'Japão',
  Jordan: 'Jordânia',
  Kazakhstan: 'Cazaquistão',
  Kenya: 'Quénia',
  Kiribati: 'Kiribati',
  Kuwait: 'Kuwait',
  Kyrgyzstan: 'Quirguistão',
  Laos: 'Laos',
  Latvia: 'Letónia',
  Lebanon: 'Líbano',
  Lesotho: 'Lesoto',
  Liberia: 'Libéria',
  Libya: 'Líbia',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lituânia',
  Luxembourg: 'Luxemburgo',
  Madagascar: 'Madagáscar',
  Malawi: 'Malawi',
  Malaysia: 'Malásia',
  Maldives: 'Maldivas',
  Mali: 'Mali',
  Malta: 'Malta',
  'Marshall Islands': 'Ilhas Marshall',
  Mauritania: 'Mauritânia',
  Mauritius: 'Maurícia',
  Mexico: 'México',
  Micronesia: 'Micronésia',
  Moldova: 'Moldávia',
  Monaco: 'Mónaco',
  Mongolia: 'Mongólia',
  Montenegro: 'Montenegro',
  Morocco: 'Marrocos',
  Mozambique: 'Moçambique',
  Myanmar: 'Myanmar',
  Namibia: 'Namíbia',
  Nauru: 'Nauru',
  Nepal: 'Nepal',
  Netherlands: 'Países Baixos',
  'New Zealand': 'Nova Zelândia',
  Nicaragua: 'Nicarágua',
  Niger: 'Níger',
  Nigeria: 'Nigéria',
  'North Korea': 'Coreia do Norte',
  Norway: 'Noruega',
  Oman: 'Omã',
  Pakistan: 'Paquistão',
  Palau: 'Palau',
  Panama: 'Panamá',
  'Papua New Guinea': 'Papua-Nova Guiné',
  Paraguay: 'Paraguai',
  Peru: 'Peru',
  Philippines: 'Filipinas',
  Poland: 'Polónia',
  Portugal: 'Portugal',
  Qatar: 'Catar',
  'Republic of the Congo': 'República do Congo',
  'Republic of Macedonia': 'República da Macedónia',
  Romania: 'Roménia',
  Russia: 'Rússia',
  Rwanda: 'Ruanda',
  'Saint Kitts and Nevis': 'São Cristóvão e Nevis',
  'Saint Lucia': 'Santa Lúcia',
  'Saint Vincent and the Grenadines': 'São Vicente e Granadinas',
  Samoa: 'Samoa',
  'San Marino': 'San Marino',
  'Sao Tome and Principe': 'São Tomé e Príncipe',
  'Saudi Arabia': 'Arábia Saudita',
  Senegal: 'Senegal',
  Serbia: 'Sérvia',
  Seychelles: 'Seychelles',
  'Sierra Leone': 'Serra Leoa',
  Singapore: 'Singapura',
  Slovakia: 'Eslováquia',
  Slovenia: 'Eslovénia',
  'Solomon Islands': 'Ilhas Salomão',
  Somalia: 'Somália',
  'South Africa': 'África do Sul',
  'South Korea': 'Coreia do Sul',
  'South Sudan': 'Sudão do Sul',
  Spain: 'Espanha',
  'Sri Lanka': 'Sri Lanka',
  Sudan: 'Sudão',
  Suriname: 'Suriname',
  Swaziland: 'Suazilândia',
  Sweden: 'Suécia',
  Switzerland: 'Suíça',
  Syria: 'Síria',
  Tajikistan: 'Tajiquistão',
  Tanzania: 'Tanzânia',
  Thailand: 'Tailândia',
  Togo: 'Togo',
  Tonga: 'Tonga',
  'Trinidad and Tobago': 'Trinidad e Tobago',
  Tunisia: 'Tunísia',
  Turkey: 'Turquia',
  Turkmenistan: 'Turquemenistão',
  Tuvalu: 'Tuvalu',
  Uganda: 'Uganda',
  Ukraine: 'Ucrânia',
  'United Arab Emirates': 'Emirados Árabes Unidos',
  'United Kingdom': 'Reino Unido',
  'United States of America': 'Estados Unidos',
  Uruguay: 'Uruguai',
  Uzbekistan: 'Uzbequistão',
  Vanuatu: 'Vanuatu',
  Venezuela: 'Venezuela',
  Vietnam: 'Vietname',
  Yemen: 'Iémen',
  Zambia: 'Zâmbia',
  Zimbabwe: 'Zimbabwe',

  TestOrganization: 'Organisation de test',
  RemovalDate: 'Date de suppression',
  IsTestOrganization: 'Est une organisation de test',
  TestingEndDate: 'Date de fin de test:',
  TestOrgConfirmationMessage:
    "L'entité a été établie comme une organisation de test et sera automatiquement supprimée à la date sélectionnée. Êtes-vous sûr de vouloir continuer ?",

  Show: 'Afficher',
  Changed: 'Changé',
  Unchanged: 'Inchangé',

  Charts: 'Graphiques',

  CreationChartLegend: 'Création',
  UpdateChartLegend: 'Mise à jour',

  Confirm: 'Confirmer',

  SelectOrInviteWarning: 'Veuillez sélectionner ou inviter',
  InvalidEmailWarning: 'Veuillez sélectionner ou saisir un e-mail valide',

  UserHasNoOrganizationsWarning:
    "Cet utilisateur ne fait partie d'aucune organisation. Veuillez l'ajouter à une organisation avant de lui attribuer des rôles.",

  UserHasNoOrganizationsGroupWarning:
    "Cet utilisateur ne fait partie d'aucune organisation. Veuillez l'ajouter à une organisation avant de l'ajouter à des groupes.",

  'Customer Geologist': 'Géologue client',
  'Drillhole Manager': 'Gestionnaire de forages',
  'Field Operator': 'Opérateur de terrain',
  Geologist: 'Géologue',
  'Global License Manager': 'Gestionnaire de licences globales',
  'License Manager': 'Gestionnaire de licences',
  'Organization Coordinator': "Coordinateur de l'organisation",
  'Organization Master': "Maître de l'organisation",
  'Partner Administrator': 'Administrateur partenaire',
  'Project Manager': 'Gestionnaire de projet',
  'Project Viewer': 'Visualiseur de projets',
  'Ring Manager': 'Gestionnaire des rings',
  ViewAllOrganizations: 'Voir toutes les organisations',
  'Organizations Viewer': "Visionneuse d'organisations",

  GlobalLicenseAlreadyExists:
    'Vous essayez de créer une nouvelle licence globale pour {0} #{1} du {6} au {7}, mais une licence globale existe déjà pour {0} #{1} du {2} au {3}, créée par {4} le {5}. Voulez-vous continuer et créer une nouvelle licence quand même ?',
  UnlimitedGlobalLicenseAlreadyExists:
    'Une licence globale illimitée a déjà été créée pour {0} #{1} par {2} le {3}. Voulez-vous continuer et créer une nouvelle licence quand même ?',
  Continue: 'Continuer',

  EditWarningGlobalLicenseAlreadyExists: 'Une licence globale a déjà été créée pour {0} #{1} du {2} au {3} par {4} le {5}. Voulez-vous continuer ?',
  EditWarningUnlimitedGlobalLicenseAlreadyExists:
    'Une licence globale illimitée a déjà été créée pour {0} #{1} par {2} le {3}. Voulez-vous continuer ?',
  EditWarningLicenseAlreadyExists:
    "Une licence a déjà été créée pour {0} #{1} du {2} au {3} par {4} le {5} dans l'organisation {6}. Voulez-vous continuer ?",
  EditWarningUnlimitedLicenseAlreadyExists:
    "Une licence illimitée a déjà été créée pour {0} #{1} par {2} le {3} dans l'organisation {4}. Voulez-vous continuer ?",

  UserLogin: 'Connexion utilisateur',
  UserAccessOrganization: "Accès de l'utilisateur à l'organisation",
  UserLogout: 'Déconnexion utilisateur',
  UserAddedToGroup: 'Utilisateur ajouté au groupe',
  UserRemovedFromGroup: 'Utilisateur retiré du groupe',
  RoleAssignedToUser: 'Rôle attribué à l’utilisateur',
  RoleUnassignedToUser: 'Rôle retiré de l’utilisateur',
  RoleAssignedToGroup: 'Rôle attribué au groupe',
  RoleUnassignedToGroup: 'Rôle retiré du groupe',
  InvitationAccepted: 'Invitation acceptée',
  BackupSuccess: 'Sauvegarde réussie',
  BackupError: 'Erreur de sauvegarde',
  RestoreBackupSuccess: 'Restauration de sauvegarde réussie',
  RestoreBackupError: 'Erreur lors de la restauration de la sauvegarde',
  PleaseEnterStartAndEndDate: 'Veuillez entrer la date de début et de fin',

  ActiveHours: 'Heures active',
  Active: 'Actif',
  NotActive: 'Non actif',
  FilterByActiveDates: 'Filtrer par dates active',
  ActiveDays: 'Jours active',
  SelectedGroupAlreadyHasTheSelectedRoles: 'Le groupe sélectionné a déjà les rôles : {0}.',

  Apply: 'Appliquer',

  FilterMode: 'Mode de filtre',
  AllSelected: 'Tous sélectionnés',
  AnyOfTheSelected: 'N’importe lequel des sélectionnés',
  Download: 'Télécharger',
  ErrorCreatingLicense: 'Erreur de création de licence',
  DeviceTypeNotAllowed: 'Type d’appareil non autorisé',

  RoleAssignmentAttributes: 'Attributs d’attribution de rôle',
  LicenseManagerRoleAttributes: 'Attributs du rôle de gestionnaire de licences',

  'StructMaster User': 'Utilisateur de StructMaster',
  UseStructMaster: 'Utiliser StructMaster',

  StructmasterLicenses: 'Licences StructMaster',
  NewStructmasterLicenseAssignment: 'Nouvelle affectation de licence StructMaster',
  EditStructmasterLicenseAssignment: 'Modifier l’affectation de licence StructMaster',
  UserAlreadyHasStructMasterRole: 'Erreur : Cet utilisateur a déjà le rôle StructMaster pour cette organisation',
  AddAnotherAssignment: 'Ajouter une autre affectation',
  AddRole: 'Ajouter un rôle',
  SelectRole: 'Sélectionner un rôle',
  PleaseSelectRole: 'Veuillez sélectionner un rôle',
  DuplicatedRolesWarning: 'Il y a des rôles en double dans votre sélection. Assurez-vous qu’il n’y a pas de doublons.',
  RolesWillBeUpdated: 'Les rôles suivants seront mis à jour : {0}.',

  UserHasNoRoleWarning: "L'utilisateur doit avoir au moins un rôle dans l'organisation",

  UserWillBeAddedToOrganizationBeforeAssign:
    "Avertissement : L'utilisateur '{0}' n'appartient pas à l'organisation '{1}' , par conséquent, l'utilisateur '{0}' sera ajouté à l'organisation avant d'effectuer l'attribution.",

  ManageCategories: 'Gérer les catégories',
  ManageGeographicInformationSystems: 'Gérer les systèmes d’information géographique',
  RoleExpirationDateChanged: 'Date d’expiration du rôle modifiée',

  Appearance: 'Apparence',
  DarkTheme: 'Thème sombre',
  LightTheme: 'Thème clair',
  UseSystemTheme: 'Utiliser le thème du système',
  MFAStatus: 'Statut de l’authentification multifacteur',
  Enabled: 'Activé',
  Disabled: 'Désactivé',
  EnableMFA: 'Activer l’authentification multifacteur',
  DisableMFA: 'Désactiver l’authentification multifacteur',

  UserLimit: 'Limite d’utilisateurs',
  PleaseEnterUserLimit: 'Veuillez entrer la limite d’utilisateurs',
  CheckLicenseInfoAndUsersTabs: 'Veuillez vérifier les onglets d’information de licence et d’utilisateurs. Quelque chose ne va pas',
  LicenseInfo: 'Informations sur la licence',
  AddNewStructmasterLicense: 'Ajouter une nouvelle licence StructMaster',
  StructmasterLicense: 'Licence StructMaster',
  PleaseAddAtLeastOneUser: 'Veuillez ajouter au moins un utilisateur',
  DuplicatedUserWarning: 'Cet utilisateur est déjà sélectionné, veuillez vérifier',
  LicenseName: 'Nom de la licence',
  UserAmountExceedLimit: 'Le nombre d’utilisateurs saisi dépasse la limite sélectionnée, veuillez vérifier que les données sont correctes.',

  UserAlreadyIsLicenseManagerError:
    'Cet utilisateur fait déjà partie d’un groupe de gestionnaires de licences. Veuillez sélectionner un autre utilisateur',
  UserAlreadyIsStructmasterUserError: 'Cet utilisateur a déjà le rôle de StructMaster. Veuillez sélectionner un autre utilisateur',
  DefaultGroups: 'Groupes par défaut',
  LicenseManagerGroups: 'Groupes de gestionnaires de licences',
  UpdateAttributes: 'Mettre à jour les attributs',
  ResetLicenseAccess: 'Réinitialiser l’accès à la licence',

  UserOnAddGroupAlreadyIsLicenseManagerError:
    'Cet utilisateur fait déjà partie d’un groupe de gestionnaires de licences, et il y a au moins un groupe de gestionnaires de licences dans votre sélection. Veuillez vérifier cela',
  MoreThanOneLicenseManagerGroupSelectedError:
    'Il y a plus d’un groupe de gestionnaires de licences dans votre sélection, et un utilisateur ne peut appartenir qu’à un seul groupe de gestionnaires de licences. Veuillez vérifier votre sélection.',
  Default: 'Par défaut',

  UnblockStructmasterLicense: 'Débloquer la licence StructMaster',

  ThereIsAlreadyAStructmasterLicenseWithThisName: 'Il existe déjà une licence StructMaster avec ce nom, veuillez choisir un autre nom.',
  ThereIsAlreadyAGroupWithThisName: 'Il existe déjà un groupe avec ce nom, veuillez choisir un autre nom',

  GroupLogsTableError: 'Une erreur s’est produite lors du chargement des journaux d’audit du groupe. Veuillez réessayer.',
  DownloadQR: 'Télécharger le QR',

  SelectUsersToShare: 'Sélectionner les utilisateurs à partager',
  SelectOrEnterEmailAddress: 'Sélectionner un utilisateur ou saisir une adresse e-mail',
  Share: 'Partager',
  NoUsersSelectedError: 'Veuillez sélectionner au moins un utilisateur ou saisir une adresse e-mail',
  AddEmail: 'Ajouter un e-mail',
  FilterByUser: 'Filtrer par utilisateur',
  ApprovalPending: 'Approbation en attente',

  ActiveUser: 'Utilisateur actif',

  AllowAllPermissionsForThisLevel: 'Autoriser toutes les permissions pour ce niveau',
  AllowAllAvailablePermissions: 'Autoriser toutes les permissions disponibles',
  AllowAllAvaliablePermissionsForThisSelector: 'Autoriser toutes les permissions disponibles pour ce sélecteur',

  StructmasterLicensesOnlyOneActiveUserWarning:
    'Avertissement : Il ne peut y avoir qu’un seul utilisateur actif à la fois pour chaque licence StructMaster.',

  OrganizationUserLimitWarningCreation: 'Avertissement : Vous ne pouvez ajouter qu’un maximum de {0} utilisateurs à une organisation',
  OrganizationUserLimitWarningParam:
    'Avertissement : Vous ne pouvez ajouter qu’un maximum de {0} utilisateurs à cette organisation, et vous en avez déjà un total de {1}, donc vous ne pourrez en ajouter que {2}.',
  OrganizationReachedUserLimit:
    'Erreur : Cette organisation a déjà atteint le nombre maximal d’utilisateurs autorisés. Veuillez sélectionner une autre organisation.',
  NewGroupUserCountErrorParam:
    'Erreur : Cette organisation a un maximum de {0} utilisateurs, avec actuellement {1} utilisateurs, et vous essayez d’en ajouter {2} nouveaux. Veuillez vérifier que les informations sont correctes.',
  TheFollowingUsersWillBeAddedToTheOrganization: 'Les utilisateurs suivants seront ajoutés à l’organisation :',

  UnsignedStructmasterLicenses: 'Licences StructMaster non signées',
  SaveAndSignOff: 'Enregistrer et signer',
  SignOffStructmasterLicenseWarningTitle: 'Signer la licence StructMaster',
  SignOffStructmasterLicenseWarningMessage:
    'Vous êtes sur le point d’approuver la création d’une nouvelle licence StructMaster. Les utilisateurs seront ajoutés à l’organisation sélectionnée s’ils n’en font pas déjà partie, et le rôle leur sera attribué. Voulez-vous continuer ?',

  ShowOnlyUnsignedLicenses: 'Afficher uniquement les licences en attente d’approbation',
  ClearFilters: 'Effacer les filtres',
  ApproveLicenses: 'Approuver les licences',

  SoftwareVersion: 'Version du logiciel',
  DeleteUnsignedLicense: 'Supprimer la licence non approuvée',
  DeleteUnsignedLicenseWarning: 'Êtes-vous sûr de vouloir supprimer la licence non approuvée « {0} » ?',
  ErrorUpdatingLicense: 'Erreur lors de la mise à jour de la licence',
  DuplicatedRoleNameErrorCreate:
    'Erreur lors de la création du rôle : Un rôle nommé "{0}" existe déjà dans l’organisation "{1}". Veuillez entrer un nom différent.',
  DuplicatedRoleNameErrorUpdate:
    'Erreur lors de la mise à jour du rôle : Un rôle nommé "{0}" existe déjà dans l’organisation "{1}". Veuillez entrer un nom différent.',
  DuplicatedDefaultRoleNameErrorUpdate:
    'Erreur lors de la mise à jour du rôle : Un rôle par défaut nommé "{0}" existe déjà. Veuillez entrer un nom différent.',
  PleaseEnterAValidSearchTerm: 'Veuillez saisir un terme de recherche valide',
  TextFieldLimitError: 'Le champ "{0}" ne doit pas dépasser {1} caractères',
  InvalidToolcode: 'Veuillez saisir un code outil valide',
  LicenseManagerGroupsMustHaveAtLeastOneRole: 'Les groupes de gestionnaire de licences doivent avoir au moins un rôle',
  PleaseSelectAtLeastOneDeviceType: 'Veuillez sélectionner au moins un type d’appareil',
  Language: 'Langue',

  UnsignedLicenseCreation: 'Création de licence non signée',
  SignedLicenseCreation: 'Création de licence signée',
  UnsignedLicenseUpdate: 'Mise à jour de la licence non signée',
  SignedLicenseUpdate: 'Mise à jour de la licence signée',
  ErrorCreatingUnsignedLicense: 'Erreur lors de la création de la licence non signée',
  ErrorCreatingSignedLicense: 'Erreur lors de la création de la licence signée',
  ErrorUpdatingUnsignedLicense: 'Erreur lors de la mise à jour de la licence non signée',
  ErrorUpdatingSignedLicense: 'Erreur lors de la mise à jour de la licence signée',
  DeleteSignedLicense: 'Supprimer la licence signée',
  StructmasterLicenseLogs: 'Journaux de licences StructMaster',
  PleaseEnterCoreDiameter: 'Veuillez saisir le diamètre du carottage',
  CoreDiameter: 'Diamètre du carottage',

  AllowedGrantTypes: 'Types d’autorisation autorisés',
  Clients: 'Clients',
  ClientsTableError: 'Une erreur est survenue lors du chargement des clients. Veuillez réessayer.',
  AllowedScopes: 'Périmètres autorisés',
  Implicit: 'Implicite',
  Hybrid: 'Hybride',
  AuthorizationCode: 'Code d’autorisation',
  ClientCredentials: 'Identifiants client',
  ResourceOwnerPassword: 'Mot de passe du propriétaire de la ressource',
  DeviceFlow: 'Flux de dispositif',
  Profile: 'Profil',
  Phone: 'Téléphone',
  OfflineAccess: 'Accès hors ligne',
  RedirectUris: 'URIs de redirection',
  PostLogoutRedirectUris: 'URIs de redirection après déconnexion',
  AccessTokenType: 'Type de jeton d’accès',
  RefreshTokenUsage: 'Utilisation du jeton d’actualisation',
  AccessTokenLifetime: 'Durée de vie du jeton d’accès',
  AbsoluteRefreshTokenLifetime: 'Durée absolue du jeton de rafraîchissement',
  AllowAccessTokensViaBrowser: 'Autoriser les jetons d’accès via le navigateur',
  AllowOfflineAccess: 'Autoriser l’accès hors ligne',
  AlwaysIncludeUserClaimsInIdToken: 'Toujours inclure les revendications utilisateur dans l’Id Token',
  RequirePkce: 'Exiger PKCE',
  RequireConsent: 'Exiger le consentement',
  RequireClientSecret: 'Exiger le secret client',
  ClientID: 'ID client',
  ClientName: 'Nom du client',
  ProtocolType: 'Type de protocole',
  NewClient: 'Nouveau client',
  EditClient: 'Modifier le client',
  General: 'Général',
  ClientSecrets: 'Secrets client',
  PleaseEnterAClientId: 'Veuillez saisir un ID client',
  PleaseEnterAClientName: 'Veuillez saisir un nom de client',
  ReUse: 'Réutiliser',
  OneTimeOnly: 'Une seule fois',
  PleaseSelectTheAllowedScopes: 'Veuillez sélectionner les périmètres autorisés',
  AddRedirectUri: 'Ajouter une URI de redirection',
  AddPostLogoutRedirectUri: 'Ajouter une URI de redirection après déconnexion',
  PleaseEnterRedirectURI: 'Veuillez saisir une URI de redirection',
  PleaseEnterPostLogoutRedirectURI: 'Veuillez saisir une URI de redirection après déconnexion',
  Value: 'Valeur',
  PleaseEnterSecretValue: 'Veuillez saisir la valeur du secret',
  PleaseEnterSecretDescription: 'Veuillez saisir la description du secret',
  AddClientSecret: 'Ajouter un secret client',
  NoRedirectUriWarning: 'Veuillez ajouter au moins une URI de redirection dans l’onglet "URIs de redirection"',
  NoPostLogoutRedirectUriWarning: 'Veuillez ajouter au moins une URI de redirection après déconnexion dans l’onglet "URIs de redirection"',
  NoSecretsWarning: 'Si "Exiger le secret client" est coché, vous devez ajouter au moins un secret dans l’onglet "Secrets client"',
  PleaseSelectTheAllowedGrantTypes: 'Veuillez sélectionner les types d’autorisation autorisés',
  RedirectURIMustNotBeEmpty: 'La valeur de l’URI de redirection ne doit pas être vide',
  PostLogoutRedirectURIMustNotBeEmpty: 'La valeur de l’URI de redirection après déconnexion ne doit pas être vide',
  SecretValueMustNotBeEmpty: 'La valeur du secret ne doit pas être vide',
  SecretDescriptionMustNotBeEmpty: 'La description du secret ne doit pas être vide',
  AllDataEnterdIsCorrect: 'Toutes les données saisies sont correctes',
  NoChangesMadeWarning: 'Aucune modification à enregistrer. Mettez à jour un champ pour continuer.',
  ConfirmEditSecretValueTitle: 'Confirmer la modification de la valeur secrète',
  ConfirmEditSecretValueMessage:
    'Êtes-vous sûr de vouloir modifier la valeur du secret avec la description "{0}" ? Si vous continuez, la valeur secrète précédente sera perdue.',
  ManageClients: 'Gérer les clients',
  Usage: 'Utilisation',

  GlobalSmartCoreLicenseAlreadyExists:
    'Vous tentez de créer une nouvelle licence globale pour {0} #{1} du {6} au {7} avec un diamètre d’outil "{8}", mais une licence globale existe déjà pour {0} #{1} avec un diamètre d’outil "{8}" du {2} au {3}, créée par {4} le {5}. Voulez-vous continuer et créer une nouvelle licence malgré tout ?',
  UnlimitedGlobalSmartCoreLicenseAlreadyExists:
    'Une licence globale illimitée existe déjà pour {0} #{1} avec un diamètre d’outil "{4}", créée par {2} le {3}. Voulez-vous continuer et créer une nouvelle licence malgré tout ?',
  EditWarningGlobalSmartCoreLicenseAlreadyExists:
    'Une licence globale existe déjà pour {0} #{1} avec un diamètre d’outil "{7}" du {2} au {3}, créée par {4} le {5}. Voulez-vous continuer ?',
  EditWarningUnlimitedGlobalSmartCoreLicenseAlreadyExists:
    'Une licence globale illimitée existe déjà pour {0} #{1} avec un diamètre d’outil "{5}", créée par {2} le {3}. Voulez-vous continuer ?',
  ToolDiameter: 'Diamètre de l’outil',
  ToolcodeTooLarge: 'Le code de l’outil est trop grand. Il doit être un nombre entre 1 et 65535',
  NotAllChildrenAreTestOrganizations:
    'Cette organisation ne peut pas être définie comme organisation de test car au moins une de ses organisations enfants n’est pas une organisation de test',
  'License Reviewer': 'Examinateur de licences',
  'Client Manager': 'Gestionnaire client',
  MeasurementCount: 'Enquêtes',
  ToolSerialNumber: 'Numéro de série de l’outil',
  ExportCsvReport: 'Exporter le rapport CSV',
  ToolType: 'Type d’outil',
  FirstUsedOn: 'Date de première utilisation',
  LastUsedOn: 'Date de dernière utilisation',
  ErrorGeneratingReport: 'Une erreur est survenue lors de la génération du rapport. Veuillez réessayer.',
  ToolUsageReport: 'Rapport d’utilisation des outils',
  ExportToolUsageReport: 'Exporter le rapport d’utilisation des outils',
  ToolUsageReportInProcess: 'Le rapport d’utilisation de l’outil est en cours de génération. Il sera envoyé à votre adresse e-mail une fois terminé.',
  ProjectName: 'Nom du projet',
  ManagePartnerOrganization: 'Gérer l’organisation partenaire',
  ManageAdminOrganization: 'Gérer l’organisation administratrice',
};
